import type { ReviewDue } from '@/types/customer-ops';

function daysUntil(dateString: string): number | null {
  const target = new Date(dateString);
  if (Number.isNaN(target.getTime())) return null;
  target.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.ceil((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

/** Manual rows and campaign readouts align with insight → proof → comms; calendar auto rows need linked proof. */
export function isProgramAlignedReviewDueRow(row: ReviewDue): boolean {
  if (row.status === 'completed') return false;
  if (row.trigger_source === 'manual') return true;
  if (row.review_type === 'improvement_campaign_readout') return true;
  return row.proof_metric_ids.length > 0;
}

/** Overdue or due within 14 days — hub priority feed and nav badge (program-aligned rows only). */
export function isPriorityReviewDueRow(row: ReviewDue): boolean {
  if (!isProgramAlignedReviewDueRow(row)) return false;
  const dueDays = daysUntil(row.due_date);
  if (dueDays === null) return true;
  return dueDays <= 14;
}

export function countPriorityReviewDueRows(rows: readonly ReviewDue[]): number {
  return rows.filter(isPriorityReviewDueRow).length;
}
